import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { VisibilityReportGenerateRequest } from '@brand24-original/llm-types';
import { generateVisibilityReport } from '../../services/visibility-report/VisibilityReportService';
import { GET_VISIBILITY_REPORTS } from '../../query/visibility-report/keys';

export const useGenerateVisibilityReport = (
  projectId: number,
  options?: { onSuccess?: (reportId: number) => void }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: VisibilityReportGenerateRequest) =>
      generateVisibilityReport(projectId, body),
    onSuccess: (report) => {
      void queryClient.invalidateQueries({ queryKey: [GET_VISIBILITY_REPORTS, projectId] });
      options?.onSuccess?.(report.id);
    },
  });
};
